export const COLLEGE_LIST_CSV_COLUMNS = {
  student_id: 1,
  student_name: 1,
  'school_#1': 1,
  'school_#1_status': 1,
  'school_#2': 1,
  'school_#2_status': 1,
  'school_#3': 1,
  'school_#3_status': 1,
  'school_#4': 1,
  'school_#4_status': 1,
  'school_#5': 1,
  'school_#5_status': 1,
  'school_#6': 1,
  'school_#6_status': 1,
  'school_#7': 1,
  'school_#7_status': 1,
  'school_#8': 1,
  'school_#8_status': 1,
  'school_#9': 1,
  'school_#9_status': 1,
  'school_#10': 1,
  'school_#10_status': 1,
  'school_#11': 1,
  'school_#11_status': 1,
  'school_#12': 1,
  'school_#12_status': 1,
  'school_#13': 1,
  'school_#13_status': 1,
  'school_#14': 1,
  'school_#14_status': 1,
  'school_#15': 1,
  'school_#15_status': 1,
  'school_#16': 1,
  'school_#16_status': 1,
  'school_#17': 1,
  'school_#17_status': 1,
  'school_#18': 1,
  'school_#18_status': 1,
  'school_#19': 1,
  'school_#19_status': 1,
  'school_#20': 1,
  'school_#20_status': 1,
};

export const VALID_COLLEGE_HEADERS = {
  'student id': 1,
  'student name': 1,
  'school #1': 1,
  'school #1 status': 1,
  'school #2': 1,
  'school #2 status': 1,
  'school #3': 1,
  'school #3 status': 1,
  'school #4': 1,
  'school #4 status': 1,
  'school #5': 1,
  'school #5 status': 1,
  'school #6': 1,
  'school #6 status': 1,
  'school #7': 1,
  'school #7 status': 1,
  'school #8': 1,
  'school #8 status': 1,
  'school #9': 1,
  'school #9 status': 1,
  'school #10': 1,
  'school #10 status': 1,
  'school #11': 1,
  'school #11 status': 1,
  'school #12': 1,
  'school #12 status': 1,
  'school #13': 1,
  'school #13 status': 1,
  'school #14': 1,
  'school #14 status': 1,
  'school #15': 1,
  'school #15 status': 1,
  'school #16': 1,
  'school #16 status': 1,
  'school #17': 1,
  'school #17 status': 1,
  'school #18': 1,
  'school #18 status': 1,
  'school #19': 1,
  'school #19 status': 1,
  'school #20': 1,
  'school #20 status': 1,
};
